class FixedDownload {
  constructor() {
    this.button = document.querySelector('.js-download-button');
    this.download = document.querySelector('.js-download-section');

    if (this.button && this.download) {
      this.init();
    }
  }

  onScroll = () => {
    const buttonRect = this.button.getBoundingClientRect();
    const downloadRect = this.download.getBoundingClientRect();

    if (downloadRect.top < buttonRect.top) {
      this.button.classList.add('isHidden');
    } else {
      this.button.classList.remove('isHidden');
    }
  };

  bindEventListeners() {
    window.addEventListener('scroll', this.onScroll);
  }

  init() {
    this.bindEventListeners();
  }
}

export default FixedDownload;
